// extracted by mini-css-extract-plugin
export default {"icon":"H_dn"};